import Vue from 'vue';

export default {
  // 获取我的采购项目列表
  getSignUpRecordList (params) {
    return Vue.axios.post('/api/v1.0/chanquan/purchase/selectPurchaseListByUserId', params);
  }
};
